import React, { useState } from "react"

import Tile from "../../components/structure/tile/tile"
import Title from "../../components/structure/title/title"
import Navigation from "../../components/ui/navigation/navigation"

import ToolConfigTab from "./_components/tool-config-tab"
import FlowCanvas from "./_components/flow-canvas"
import { AI_TOOLS } from "./registry"
import { SUPPLIER_DOCUMENT_FLOW_ID } from "./_seeds/supplier-document-flow"

import "./ai-tooling.scss"
// Reuse the AI-tools panel styles for the inputs/result blocks so this page
// matches the Enquiry Ingest panel aesthetic.
import "../communications/_components/ai-tools/panel.scss"

const VIEWS = [
	{ id: "tools", label: "Tools" },
	{ id: "flow", label: "Flow" },
]

/**
 * AI Tooling — super-admin-only page for editing the prompts, models, and
 * response schemas of every AI tool the app ships with. Configurations live
 * in Firestore at `ai_tooling/{tool-id}` (see `registry.js` for the tool
 * list).
 *
 * Two views share the page:
 *   - "Tools": one tab per tool, each rendering the generic config form.
 *   - "Flow":  a full-width canvas of the pipeline the tools form, with the
 *              same configs reachable by clicking a node (see flow-canvas.js).
 */
function AiTooling() {
	const [view, setView] = useState("tools")
	const [activeTab, setActiveTab] = useState(AI_TOOLS[0].id)
	const activeTool = AI_TOOLS.find((tool) => tool.id === activeTab) || AI_TOOLS[0]

	const isFlow = view === "flow"

	return (
		<Tile fullPage={true}>
			<div className={["ai-tooling-page", isFlow && "is-flow"].filter(Boolean).join(" ")}>
				<Title className="flex">
					<h1>AI Tooling</h1>
				</Title>

				<div className="ai-tooling-views">
					<Navigation links={VIEWS} active={view} onClick={setView} />
				</div>

				{isFlow ? (
					<FlowCanvas initialFlowId={SUPPLIER_DOCUMENT_FLOW_ID} />
				) : (
					<>
						<div className="ai-tooling-tabs">
							<Navigation
								links={AI_TOOLS.map((tool) => ({ id: tool.id, label: tool.label }))}
								active={activeTab}
								onClick={setActiveTab}
							/>
						</div>

						<ToolConfigTab key={activeTool.id} tool={activeTool} />
					</>
				)}
			</div>
		</Tile>
	)
}

export default AiTooling
